// extracted by mini-css-extract-plugin
module.exports = {"imageMode":"swipeableTabs_imageMode__3iV4V","tab":"swipeableTabs_tab__2MDlY"};